import React from 'react';
import { Form, Input, DatePicker } from 'antd';
import locale from 'antd/lib/date-picker/locale/ru_RU';
const { Group } = Input;

const OrdersForPeriod = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const valueFrom = getFieldValue('ordersForPeriodFrom');
  const valueTo = getFieldValue('ordersForPeriodTo');

  return (
    <Form.Item label="Имеются заказы за период" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('ordersForPeriodFrom')(
          <DatePicker
            locale={locale}
            disabledDate={startValue =>
              valueTo && startValue.valueOf() > valueTo.valueOf()
            }
            style={{ width: '50%' }}
            placeholder="от"
            format={'DD.MM.YYYY'}
          />
        )}
        {getFieldDecorator('ordersForPeriodTo')(
          <DatePicker
            locale={locale}
            style={{ width: '50%' }}
            disabledDate={endValue =>
              valueFrom && endValue.valueOf() <= valueFrom.valueOf()
            }
            placeholder="до"
            format={'DD.MM.YYYY'}
          />
        )}
      </Group>
    </Form.Item>
  );
};
export default OrdersForPeriod;
